import { getKeycloakToken } from '../../utils/getKeycloakToken';
import { API_BASE_URL } from '../../utils/utils';

export enum MethodType {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}
const APICaller = async (
  route: string,
  method: MethodType,
  data: any = null,
  isFormData: boolean = false,
) => {
  const jwtToken = await getKeycloakToken();
  const url = `${API_BASE_URL}${route}`;
  const headers: HeadersInit = {
    Accept: 'application/json',
  };
    if (jwtToken) {
    headers.Authorization = `Bearer ${jwtToken}`;
  }
  if (!isFormData) {
    headers['Content-Type'] = 'application/json';
  }
  // console.log(headers);
  const fetchOptions: RequestInit = {
    method,
    headers,
  };

  if (data) {
    fetchOptions.body = isFormData ? data : JSON.stringify(data);
  }
  const response = await fetch(url, fetchOptions);
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.errorMessage || 'API call failed');
  }

  return response.json();
};

export default APICaller;
